import { RefBool, Collection } from '@tblabs/truffle';
import { DeviceConfigForWatcher } from '../Models/DeviceConfig';
import { ICamera } from '../Services/Camera/ICamera';
import { ConnectionStatusEvent } from '../Services/ConnectionStatusEvent';
import { InputState } from '../Models/SensorState';
import { Status } from '../Services/Status/Status';
import { StatusEvent } from '../Services/Status/StatusEvent';
import { Sensor } from '../Models/Sensor';
import { Beepers } from "../Services/Beepers";
import { Vibra } from './Components/VibraBox';
import { IoState } from '../Services/Camera/IoState';


export class IoLogic
{
    public Sensors = new Collection<Sensor>();
    public Vibrators = new Collection<Vibra>();
    public ShowSensorsBox = new RefBool(false);
    public ShowVibraBox = new RefBool(false);
    private onConnectionChangeHandlerId: string;
    private onConfigReceivedHandlerId: string;
    private onInputChangeHandlerId: string;
    private onInputMalfunctionHandlerId: string;
    private onIoStateChangeHandlerId: string;
    private isInitialized = false;

    constructor(private _camera: ICamera, private _status: Status, private _beepers: Beepers)
    {
        this.onConnectionChangeHandlerId = this._camera.OnConnectionChange.Subscribe((status: ConnectionStatusEvent) =>
        {
            if (status.IsNotConnected)
            {
                this.ResetAllSensors();
                _beepers.StopAll();
            }
        });

        this.onConfigReceivedHandlerId = this._camera.OnConfigReceived.Subscribe((config: DeviceConfigForWatcher) =>
        {
            this.SetupIo(config.Hardware?.InputsNames ?? [], config.Hardware?.OutputsNames ?? []);
        });

        this.onInputChangeHandlerId = this._camera.OnInputChange.Subscribe((input: InputState) =>
        {
            this.SetInput(input);

            this._beepers.InputActive(input);

            this._status.InputActive(input.Name);

            if (!this.IsAnySensorActive)
                this._status.Set(StatusEvent.InputInactive);
        });

        this.onInputMalfunctionHandlerId = this._camera.OnInputMalfunction.Subscribe((inputName: string) =>
        {
            this.SetInputMalfunction(inputName);
            _beepers.StopInput(inputName);
        });

        this.onIoStateChangeHandlerId = this._camera.OnIoStateChange.Subscribe((ioState: IoState) =>
        {
            if (!ioState)
                return;

            this.SetupIo(Object.keys(ioState.InputsState), Object.keys(ioState.OutputsState));

            this.Sensors.ForEach(sensor =>
            {
                sensor.SetValue(ioState?.InputsState?.[sensor.Id]);
                sensor.Malfunction(ioState?.InputsMalfunction?.includes(sensor.Id) ?? false);
            });
        });

        // TODO: tu by się przydało jeszcze pobrać aktualny stan czujników, bo w razie odświeżenia strony jeśli czujnik jest aktywny to tego nie zauważymy (bo jest to zdarzenie onchange)
    }

    private SetupIo(inputsNames: string[], outputsNames: string[]): void
    {
        if (!inputsNames || !outputsNames)
            return;

        // if (config.Hardware)
        // {
        this.DoItOnce(() =>
        {
            // const inputsNames = config.Hardware.InputsNames ?? [];
            // const outputsNames = config.Hardware.OutputsNames ?? [];

            this.CreateIo(inputsNames, outputsNames);

            this.ShowSensorsBox.value = inputsNames.length > 0;
            this.ShowVibraBox.value = outputsNames.length > 0;

            this._beepers.Init(inputsNames);
        });
        // }
        // else console.log("Warning: Config does not contain Hardware definition. Old version of device?");
    }

    private DoItOnce(action: () => void): void
    {
        if (this.isInitialized)
            return;

        this.isInitialized = true;

        action();
    }

    public CreateIo(inputsNames: string[], outputsNames: string[]): void
    {
        try
        {
            if (inputsNames.length > 0)
            {
                const sensors: Sensor[] = inputsNames.map((name, index) => new Sensor(name, "#" + (index + 1)));
                this.Sensors.Load(...sensors);
            }

            if (outputsNames.length > 0)
            {
                const vibrators: Vibra[] = outputsNames.map((name, index) => new Vibra(this._camera, name, "#" + (index + 1)));
                this.Vibrators.Load(...vibrators);
            }
        }
        catch (error)
        {
            console.error('CreateIo', error);
        }
    }

    public SetInput(input: InputState): void
    {
        const sensor = this.Sensors.Find(sensor => sensor.Id == input.Name);

        sensor?.SetValue(input.Value);
    }

    public get IsAnySensorActive(): boolean
    {
        return this.Sensors.Items.some(sensor => sensor.IsActive);
    }

    public SetInputMalfunction(inputName: string): void
    {
        const sensor = this.Sensors.Items.find(sensor => sensor.Id == inputName);
        sensor?.Malfunction();
    }

    public ResetAllSensors(): void
    {
        this.Sensors.ForEach(sensor => sensor.Reset());
    }

    public Dispose(): void
    {
        this._camera.OnConnectionChange.Unsubscribe(this.onConnectionChangeHandlerId);
        this._camera.OnConfigReceived.Unsubscribe(this.onConfigReceivedHandlerId);
        this._camera.OnInputChange.Unsubscribe(this.onInputChangeHandlerId);
        this._camera.OnInputMalfunction.Unsubscribe(this.onInputMalfunctionHandlerId);
        this._camera.OnIoStateChange.Unsubscribe(this.onIoStateChangeHandlerId);
        this.ResetAllSensors();
        this._beepers.StopAll();
    }
}
